export default __webpack_public_path__ + "static/glass-8-5dbefaf6f7718d0a8336c73f45133114.jpg";